import { render, staticRenderFns } from "./HorizontalSlider.vue?vue&type=template&id=8b915708"
import script from "./HorizontalSlider.vue?vue&type=script&lang=js"
export * from "./HorizontalSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports